import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {Container} from 'reactstrap';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import ServiceCentersPageData from 'Models/Content/ServiceCentersPageData';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';

import ServiceCentersSearch from './ServiceCentersSearch';

type ServiceCentersPageBlockProps = {
  data: ServiceCentersPageData;
  context: IEpiserverContext;
};

const ServiceCentersPageBlock = ({data, context}: ServiceCentersPageBlockProps) => {
  const {mainContentArea, title, subtitle, searchHintTitle} = data;
  const isIdf = false;
  return (
    <div className='ServiceCentersPage'>
      <div className='ServiceCentersPage__search__container'>
        <div className='ServiceCentersPage__search'>
          <h1 className='ServiceCentersPage__title'>{title.value}</h1>
          <h3 className='ServiceCentersPage__subtitle'>{subtitle.value}</h3>
          <ServiceCentersSearch placeholder={searchHintTitle.value} isIdf={isIdf} onSelectChange={null} selectedCenter={null} />
          <div className='ServiceCentersPage__info'>
            <Image src={require('./images/service-center.svg')} />
            <div className='ServiceCentersPage__info__title'>מצאו מרכז שירות</div>
            <div className='ServiceCentersPage__info__subtitle'>הקלידו את עיר מגוריכם ומצאו את המרכז הקרוב אליכם</div>
          </div>
        </div>
      </div>
      <div className='ServiceCentersPage__content__container'>
        <div className='ServiceCentersPage__content'>
          <ContentArea data={mainContentArea} context={context} />
        </div>
      </div>
    </div>
  );
};

export default class ServiceCentersPage extends Page<ServiceCentersPageData> {
  render() {
    return <ServiceCentersPageBlock data={this.props.data} context={this.props.context} />;
  }
}
